function openMedia(event, tabId) {
  // Remove 'active' class from all tabs and tab content
  const tabButtons = document.querySelectorAll(".media-button");
  const tabContents = document.querySelectorAll(".media-content");
  tabButtons.forEach((button) => button.classList.remove("active"));
  tabContents.forEach((content) => content.classList.remove("active"));

  // Add 'active' class to clicked tab and related content
  event.currentTarget.classList.add("active");
  document.getElementById(tabId).classList.add("active");
}
